module.exports = {"note":"modified version of friend-1-vert for AB testing","platforms":[{"message":"Start Platform","type":"FiniteImmobilePlatform","x":8,"y":13,"width":5,"height":3,"display":{"assetName":"temple"}},{"message":"Goal Platform","type":"FiniteImmobilePlatform","x":15,"y":4,"width":5,"height":12,"display":{"assetName":"temple"}}],"goal":{"x":18,"y":4},"player":{"x":9,"y":12},"par":1,"scale":32}


//////////////////
// WEBPACK FOOTER
// ./node_modules/json-loader!./levels/new-1-vert-ab.json
// module id = 146
// module chunks = 0